const { createApp } = Vue;

createApp({
    delimiters: ["[[", "]]"],
    data() {
        return {
            type: "selection",
            selectedCard: null,
            giftBoxes: [],
            giftCards: [],
            giftBags: [],
            giftCardAdded: false,
            giftBagAdded: false,
            giftBoxAdded: false,
            giftBoxProducts: [
                "https://scentsnstories.pk/products/gift-wrapping.json",
            ],
            giftCardsProducts: [
                "https://scentsnstories.pk/products/gift-card-sheet.json",
            ],
            giftBagsProducts: [
                "https://scentsnstories.pk/products/gift-bag.json",
            ],
        };
    },
    async mounted() {
            console.log("mounted from js",tags);
        // console.log("tags 23",tags)
        if (tags.includes("giftxpok")) {
          this.init();
        }
    },
    methods: {
        init() {
            let html = "";
            html = '<div class="custom_dropdown">';
            html += `<label>Is it a gift?</label>`;
            html += `<div><label class="switch"><input type="checkbox" class="openGiftModal" id="myBtn"><span class="slider round"></span></label></div>`;
            // html +=  `<div class="button r" id="button-1"><input type="checkbox" class="checkbox openGiftModal"><div class="knobs"></div><div class="layer"></div></div>`;
            html += "</div>";

            // $(".shopify-product-form").prepend(html);
            // $(".product-single__meta").prepend(html);
            $(".shopify-product-form").prepend(html);
          

            console.log("mounted");
            // Get the modal
            var modal = document.getElementById("myModal");

            var checkbox = document.getElementsByClassName("openGiftModal")[0];

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("gift-modal-close")[0];

            // // When the user clicks on the button, open the modal
            // btn.change = function (event) {
            //     console.log("onclick",event);

            // }

            checkbox.addEventListener("click", (event) => {
                // if (event.currentTarget.checked) {
                modal.style.display = "block";
                document.body.style.overflowY = "hidden";
                // } else {

                // }
            });

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
                document.body.style.overflowY = "auto";
            };

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = (event) => {
                console.log("this.dataset", event.target.dataset.type);
                if (event.target == modal) {
                    modal.style.display = "none";
                    document.body.style.overflowY = "auto";
                }
                if (event.target.dataset.action == "openGiftModal") {
                    modal.style.display = "block";
                    document.body.style.overflowY = "hidden";
                    if (event.target.dataset.type) {
                        this.selectType(event.target.dataset.type);
                    }
                }
            };

            this.getProducts(this.giftBoxProducts).then((response) => {
                console.log("response", response);
                this.giftBoxes = response;
            });
            this.getProducts(this.giftCardsProducts).then((response) => {
                console.log("response", response);
                this.giftCards = response;
                console.log("this.giftCards", this.giftCards);
            });
            this.getProducts(this.giftBagsProducts).then((response) => {
                this.giftBags = response;
                console.log("this.giftBags", this.giftBags);
            });
        },
        hideModal() {
            var modal = document.getElementById("myModal");
            modal.style.display = "none";
            document.body.style.overflowY = "auto";
        },
        test() {
            console.log("Test");
        },
        async getProducts(product_urls) {
            let products = [];
            for (let giftbox of product_urls) {
                const { data } = await axios.get(giftbox);
                let product = data.product;
                for (let variant of product.variants) {
                    variant.image = product.images.find(
                        (i) => i.id == variant.image_id
                    );
                    variant.added = false;
                }
                products.push(product);
                // console.log("getProducts", products)
            }

            return products;
        },
        addToCart() {
            // type: "selection",
            //  selectedCard: null,
            //  giftBoxes: [],
            //  giftCards: [],
            //  giftBags: [],
            let properties = "";
            let variant;

            if (this.type == "giftcard") {
                for (let index in this.giftCards) {
                    let product = this.giftCards[index];
                    variant = product.variants.find(
                        (x) => x.id == this.selectedCard.id
                    );
                    variant.added = true;
                }
                this.giftCardAdded = true;
            }
            if (this.type == "giftwrap") {
                for (let product of this.giftBoxes) {
                    variant = product.variants.find(
                        (x) => x.id == this.selectedCard.id
                    );
                    variant.added = true;
                }
                this.giftBoxAdded = true;
            }
            if (this.type == "giftbag") {
                for (let product of this.giftBags) {
                    variant = product.variants.find(
                        (x) => x.id == this.selectedCard.id
                    );
                    variant.added = true;
                }
                this.giftBagAdded = true;
            }

            properties += `<input type="hidden" name="properties[${this.type}]" value="${variant.title}">`;
            $(".shopify-product-form").prepend(properties);
            let formData = {
                items: [
                    {
                        id: this.selectedCard.id,
                        quantity: 1,
                    },
                ],
            };
            fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            })
                .then((response) => {
                    console.log("response0", response);
                    return response.json();
                })
                .then((response) => {
                    console.log("response", response);
                    //this.hideModal();
                    this.showMessage();
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        },
        showMessage() {
            $("#gift_card").remove();
            $(".custom_dropdown").remove();
            let html = `<div id="gift_card">`;

            let message = "";

            if (this.giftCardAdded) {
                message = "Gift Card Added";
                html += `<div class="giftMessage"><img width="30" height="30" src="https://img.icons8.com/fluency/48/gift-card.png" alt="gift--v1">${message}<img width="20" height="20" src="https://img.icons8.com/fluency/48/checked.png" alt="checked"></div>`;
            }
            if (this.giftBagAdded) {
                message = "Gift Bag Added";
                html += `<div class="giftMessage"><img width="30" height="30" src="https://img.icons8.com/external-vitaliy-gorbachev-flat-vitaly-gorbachev/58/external-gift-bag-chinese-new-year-vitaliy-gorbachev-flat-vitaly-gorbachev.png" alt="gift--v1">${message}<img width="20" height="20" src="https://img.icons8.com/fluency/48/checked.png" alt="checked"></div>`;
            }
            if (this.giftBoxAdded) {
                message = "Gift Wrap Added";
                html += `<div class="giftMessage"><img width="30" height="30" src="https://img.icons8.com/color/48/gift--v1.png" alt="gift--v1">${message}<img width="20" height="20" src="https://img.icons8.com/fluency/48/checked.png" alt="checked"></div>`;
            }

            if (message) {
            }

            if (this.giftCardAdded == false) {
                html += `<div><a href="#" class="openGiftModal text-primary italic" data-action="openGiftModal" data-type="giftcard">Add Gift Card</a></div>`;
            }
            if (this.giftBagAdded == false) {
                html += `<div><a href="#" class="openGiftModal text-primary italic" data-action="openGiftModal" data-type="giftbag">Add Gift Bag</a></div>`;
            }
            if (this.giftBoxAdded == false) {
                html += `<div><a href="#" class="openGiftModal text-primary italic" data-action="openGiftModal" data-type="giftwrap">Add Gift Wrap</a></div>`;
            }
            $(".shopify-product-form").prepend(html);
        },
        selectType(type) {
            this.type = type;
            this.selectedCard = null;

            if (type == "giftwrap") {
                this.selectedCard = this.giftBoxes[0].variants[0];
            }

            if (type == "giftcard") {
                this.selectedCard = this.giftCards[0].variants[0];
            }
            if (type == "giftbag") {
                this.selectedCard = this.giftBags[0].variants[0];
            }
        },
    },
}).mount("#custom_giftcard");
